import React from 'react';
import DetailsPage from '../components/DetailsPage';

function PropertyTax() {
  // Sample data - in a real application, this would come from an API
  const propertyTaxData = [
    {
      id: 1,
      propertyHolderName: 'John Doe',
      wordNo: 'Ward 1',
      year: '2023',
      amount: '₹5000'
    },
    {
      id: 2,
      propertyHolderName: 'Jane Smith',
      wordNo: 'Ward 2',
      year: '2023',
      amount: '₹7500'
    },
    {
      id: 3,
      propertyHolderName: 'Robert Johnson',
      wordNo: 'Ward 3',
      year: '2023',
      amount: '₹6000'
    }
  ];

  const columns = [
    { field: 'propertyHolderName', header: 'Property Holder Name' },
    { field: 'wordNo', header: 'Word No' },
    { field: 'year', header: 'Year' },
    { field: 'amount', header: 'Amount' }
  ];

  const handleRowClick = (row) => {
    console.log('Row clicked:', row);
  };

  return (
    <DetailsPage
      title="Property Tax Records"
      backPath="/dashboard"
      columns={columns}
      data={propertyTaxData}
      onRowClick={handleRowClick}
    />
  );
}

export default PropertyTax; 